const HeaderComponent = () => {
  return (
    <div className="flex items-center gap-2">
      <h2 className="font-semibold text-sm ">Staff Calendar</h2>
    </div>
  );
};

export default HeaderComponent;
